import { render, staticRenderFns } from "./CategoryList-v2.vue?vue&type=template&id=4101a2cb&scoped=true&"
import script from "./CategoryList-v2.vue?vue&type=script&lang=js&"
export * from "./CategoryList-v2.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList-v2.vue?vue&type=style&index=0&id=4101a2cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4101a2cb",
  null
  
)

export default component.exports